module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/pets//blue_3.png?v=737ea695";